<template>
    <div class="school">
        <div class="banner">
            <div class="banner-center center">
                <div class="banner-info">
                    <div class="btn shenqing bgRed" @click="openDialog('免费试用',0)">申请试用</div>
                </div>
            </div>
        </div>
        <div class="item_1">
            <div class="item-title">
                <h3 class="title2">360°提升机构竞争力</h3>
                <div class="marker"></div>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item1_list" >
                        <div class="title">
                            <img :src="'static/img/school/item1_title_'+(index+1)+'.png'" alt="">
                        </div>
                        <div class="content">
                            <div class="image">
                                <img :src="'static/img/school/item1_content_'+(index+1)+'.png'" alt="">
                            </div>
                            <div class="info">{{x.info}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item_2">
            <div class="item-title">
                <h3 class="title2">千校辅导，见证机构蜕变</h3>
                <div class="marker"></div>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item2_list" >
                        <div class="image">
                            <img :src="'static/img/service/item3_'+(index+1)+'.png'" width='100%' height='100%'  alt="">
                        </div>
                        <div class="title">{{x.title}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item_3">
            <div class="item-title">
                <h3 class="title2">产业学院课程指导</h3>
                <div class="marker"></div>
            </div>
            <div class="item-contents center">
                <ul>
                    <li>
                        <img :src="'static/img/school/item3_1.png'" alt="">
                    </li>
                    <li>
                        <img :src="'static/img/school/item3_2.png'" alt="">
                    </li>
                    <li>
                        <img :src="'static/img/school/item3_3.png'" alt="">
                    </li>
                </ul>
            </div>
        </div>
        <div class="item_4">
            <div class="item-title">
                <h3 class="title2">节假日活动策划</h3>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item3_list" >
                        <div class="image">
                            <img :src="'static/img/school/item4_'+(index+1)+'.png'" alt="">
                        </div>
                        <div class="title">{{x.info}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item_5">
            <div class="item-title">
                <h3 class="title2">整合对接行业优质资源</h3>
                <div class="marker"></div>
            </div>
            <div class="item-contents center">
                <ul>
                    <li v-for="(x,index) in item5_list" v-if="index<=5" >
                        <div class="image">
                            <img :src="'static/img/school/item5_'+(index+1)+'.png'" alt="">
                        </div>
                        <div class="title">{{x.title}}</div>
                    </li>
                    <li>
                        <div class="title">......</div>
                    </li>
                </ul>
            </div>
        </div>
        <shen-qing></shen-qing>
    </div>
</template>

<script>
import shenQing from "./shenqing.vue";
export default {
    components: {
        shenQing
    },
    data(){

        return{
            item1_list:[
                {info:"多维度数据统计分析，查找机构运营问题"},
                {info:"教培行业资深培训师+专业数据分析师，下校1V1辅导"},
                {info:"推广+招生+运营+家校+续费+团队+财务等多方位运营辅导"},
            ],
            item2_list:[
               {img:"",title:"曼舞空间舞蹈"},
                {img:"",title:"舞+舞"},
                {img:"",title:"咔咔舞蹈家园"},
                {img:"",title:"乐音音乐"},
                {img:"",title:"新星教育"},
                {img:"",title:"沐点艺术空间"},
                {img:"",title:"木兰ML舞蹈"},
                {img:"",title:"小红花艺术团"},
                {img:"",title:"莱音音乐培训中心"},
                {img:"",title:"哈妮公主舞蹈艺术中心"},
                {img:"",title:"清风围棋"},
                {img:"",title:"0531街舞"},
                {img:"",title:"风之舞"},
                {img:"",title:"钢花艺校"},
                {img:"",title:"棒棒堂"},
            ],
            item3_list:[
                {info:"节日活动营销模板"},
                {info:"节日活动方案"},
                {info:"定制化活动方案"},
            ],
            item5_list:[
                {title:"财税"},
                {title:"投融资"},
                {title:"研学"},
                {title:"商学"},
                {title:"课程"},
                {title:"科技"},
                {title:"......"},
            ]
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{
        openDialog:function(title,type){//type:(0机构,1微官网)
              this.$parent.$refs.openPop.openDialog(title,type);
          }
    }
}
</script>

<style scoped lang="less">
.banner {
        width: 100%;
        height: 480px;
        margin-top: 80px;
        background: url("https://cdntest.yizhiniao.com/newWebsite_/school/banner.jpg") no-repeat center;

        .banner-center {
            height: 100%;
            position: relative;
        }

        .banner-info {
            position: absolute;
            bottom: 90px;
            left: 63px;
            text-align: left;
        }
    }
    .item_1{
        padding:164px 0 80px;
        .item-contents{
            margin:80px auto 0;
            padding:0 40px;
            height:470px;
            ul{
                display: flex;
                justify-content: space-between;
                li{
                    width: 350px;
                    height: 450px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 30px 0px #E9E9E9;
                    border-radius: 16px;
                    .title{
                        width: 100%;
                        height: 100px;
                    }
                    div.content{
                        width: 100%;
                        height: 350px;
                        padding:60px 50px 30px;
                        position: relative;
                        .image{
                            width:140px;
                            height:140px;
                            margin:0 auto;
                        }

                        .info{
                            text-align: left;
                            padding: 0 50px;
                            font-size: 16px;
                            columns: #646464;
                            line-height: 22px;
                            position: absolute;
                            bottom:30px;
                            left:0;
                        }
                    }
                }
            }
        }
    }
    .item_2{
        .item-title{
            width: 100%;
            height:345px;
            padding:140px 0 123px;
            background:url("https://cdntest.yizhiniao.com/newWebsite_/common/tiao1_bg.png") no-repeat center;
        }
        .item-contents{
            padding:0 20px 84px;
            margin-top: -40px;
            ul{
                margin:0 auto;
                width: 1160px;
                height: 1200px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li{
                    width:360px;
                    height:240px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 40px 0px rgba(225, 220, 220, 0.5);
                    .image{
                        width: 100%;
                        height: 180px;
                    }
                    .title{
                        width: 100%;
                        height:60px;
                        line-height: 60px;
                        text-align: center;
                        font-size: 20px;
                        font-weight: 500;
                        color: #4A4A4A;
                    }
                }
            }
        }
    }
    .item_3{
        .item-contents{
            margin-top: 80px;
            padding-bottom:180px;
            ul{
                display:flex;
                justify-content: space-between;
                li{
                    width: 360px;
                    height: 240px;
                }
            }
        }
    }
    .item_4{
        width: 100%;
        height: 768px;
        padding:104px 0 120px;
        background: url(https://cdntest.yizhiniao.com/newWebsite_/school/item4_bg.jpg) no-repeat center;
        .title2{
            color:#fff;
        }
        .item-contents{
            margin-top: 72px;
            ul{
                width: 1100px;
                margin:0 auto;
                display:flex;
                justify-content: space-between;
                li{
                    width: 358px;
                    height:398px;
                    padding:75px 0 40px;
                    .image{
                        width:360px;
                        height:220px;
                    }
                    .title{
                        margin:37px;
                        text-align: center;
                        color:#fff;
                        font-size: 20px;
                        line-height: 28px;
                    }
                }
            }
        }
    }
    .item_5{
        padding:180px 0;
        .item-contents{
            margin-top: 80px;
            ul{
                width: 1160px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                li{
                    width: 138px;
                    height:138px;
                    background: #FFF8F8;
                    border: 1px solid rgba(196, 89, 89, 0.3);
                    &:last-child{
                        line-height: 138px;
                    }
                    .image{
                        width: 60px;
                        height: 60px;
                        margin:20px auto 7px;
                    }
                    .title{
                        text-align:center;
                        font-size:24px;
                        font-weight: 300;
                        color: #1E1E1E;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/school.vue